import axiosInstance from "@/lib/axios";
import type { question } from "@/features/simulationConfiguration/types.api";
import type { paginatedResponse } from "@/types/api/paginated.api";

interface simulationStatus {
    status: string;
    current_answers: Record<string, string>;
    session_1_start_time: string | null;
    session_2_start_time: string | null;
}

export const getVirtualSimulationState = async (
    simulationId: string,
): Promise<simulationStatus> => {
    const { data } = await axiosInstance.get(
        `/reports/student/simulations/${simulationId}/virtual-simulation/`,
    );
    return data;
};

export const getSessionQuestions = async (
    simulationId: string,
    sessionNum: number,
    testId: number,
): Promise<paginatedResponse<question>> => {
    const { data } = await axiosInstance.get(
        `/simulations/${simulationId}/sessions/${sessionNum}/tests/${testId}/questions/`,
    );
    return data;
};

export const startSession = async (
    simulationId: string,
    sessionNumber: number,
): Promise<{ status: string; start_time: string }> => {
    const { data } = await axiosInstance.post(
        `/reports/student/simulations/${simulationId}/virtual-simulation/start-session/`,
        { session_number: sessionNumber },
    );
    return data;
};

export const submitSession = async (
    simulationId: string,
    sessionNumber: number,
    answers: Record<string, string>,
): Promise<void> => {
    await axiosInstance.post(
        `/reports/student/simulations/${simulationId}/virtual-simulation/submit-session/`,
        {
            session_number: sessionNumber,
            answers: answers,
        },
    );
};

export const autoSaveAnswers = async (
    simulationId: string,
    answers: Record<string, string>,
): Promise<void> => {
    await axiosInstance.patch(
        `/reports/student/simulations/${simulationId}/virtual-simulation/`,
        {
            answers,
        },
    );
};
